import { render } from "./DeleteInvoiceDialog.vue?vue&type=template&id=d3c6c242&ts=true"
import script from "./DeleteInvoiceDialog.ts?vue&type=script&lang=ts"
export * from "./DeleteInvoiceDialog.ts?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__